<app-header></app-header>
<app-botao-chat></app-botao-chat>

<div class="container py-4">
  <div class="card-pedido-processado">
    <app-breadcrumb></app-breadcrumb>
    <div class="titulo-pedido-processado">
      <h1>Seu pedido foi processado</h1>
      @if (isPrePago) {
        <p>Caro cliente,<br>
          Seu pedido de número <span>{{detalhesPedido?.detalhe?.numeroPedido}}</span> já foi processado e está previsto
          para ser pago em <span>{{$safeNavigationMigration(detalhesPedido?.detalhe?.dataEntrega) | appDate: 'dd/MM/yyyy'}}</span>.
        </p>
      }
      @if (!isPrePago) {
        <p>Caro cliente,<br>
          Seu pedido de número <span>{{detalhesPedido?.detalhe?.numeroPedido}}</span> já foi processado.
        </p>
      }
    </div>
    <div class="dados-pedido-processado">
      <div class="top-pedido-processado">
        <div class="col-2">
          <span>CNPJ</span>
          <p>{{$safeNavigationMigration(detalhesPedido?.detalhe?.cnpj) | cnpj}}</p>
        </div>
        <div class="col">
          <span>RAZÃO SOCIAL</span>
          <p>{{detalhesPedido?.detalhe?.razaoSocial}}</p>
        </div>
      </div>
      <div style="width: 100%;display: flex;justify-content: space-between;margin-top: 40px">
        <div class="col-2">
          <span>TAXAS</span>
          <p>{{$safeNavigationMigration(detalhesPedido?.detalhe?.totalTaxas) | currency:"BRL"}}</p>
        </div>
        <div class="col">
          <span>DESCONTOS</span>
          <p>{{$safeNavigationMigration(detalhesPedido?.detalhe?.totalDescontos) | currency:"BRL"}}</p>
        </div>
        <div class="col">
          <span>TOTAL DE PRODUTOS</span>
          <p>{{$safeNavigationMigration(detalhesPedido?.detalhe?.totalProdutos) | currency:"BRL"}}</p>
        </div>
        <div class="col">
          <span>TOTAL DE PEDIDOS</span>
          <p>{{$safeNavigationMigration(detalhesPedido?.detalhe?.totalPedido) | currency:"BRL"}}</p>
        </div>
        <div class="col">
          <span>TOTAL A PAGAR</span>
          <p>{{$safeNavigationMigration(detalhesPedido?.detalhe?.totalPagar) | currency:"BRL"}}</p>
        </div>
      </div>
    </div>
    <div class="info-pedido-processado">
      <div>
        <h1>O que eu faço agora?</h1>
      </div>
      <div class="passos-pedido-processado">
        <div style="display: flex;margin-bottom: 20px">
          <div class="numero-passo">1</div>
          <p>Aguarde a entrega do seu pedido que será realizada desde que o pagamento seja efetuado dentro do prazo;</p>
        </div>
        <div style="display: flex;margin-bottom: 20px">
          <div class="numero-passo">2</div>
          <p>A realização do pagamento em data anterior ou posterior à informada no pedido implicará a respectiva <br>
          antecipação ou prorrogração da entrega na mesma quantidade de dias;</p>
        </div>
        <div style="display: flex">
          <div class="numero-passo">3</div>
          <p>Após a confirmação do pagamento, a data correta da entrega poderá ser verificada em Pedidos, <a routerLink="/listar-pedidos">Basta clicar em <br>
          Listar Pedidos</a>, caso haja mais um local de entrega ou benefícios com prazos de entrega diferentes.</p>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
